import { ValueGetterParams } from "ag-grid-community";
import React, { useState, useRef } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { WorkflowStateCellValueGetter } from "../grid/renderers/WorkflowStateCellValueGetter";
import { formatDate } from "../helper/dateFormatter";
import { calculateDayDifference } from "../pages/PatientProfile/PGI";
import { UserName } from "../components/UserName";

export const ColoredTestRenderer = (params: ValueGetterParams) => {
  const [showPopover, setShowPopover] = useState(false);
  const targetRef = useRef(null);

  if (params && params.data && params.data.stateName) {
    const status = params.data.stateName?.toLowerCase();

    const handleToggle = (nextShow: boolean) => {
      if (status === "rejected") {
        setShowPopover(nextShow);
      }
    };

    const popover = (
      <Popover style={{ maxWidth: "300px" }}>
        <Popover.Body className="rounded-1 p-4" style={{ backgroundColor: "#CFDEEE" }}>
          <div>
            <div className="d-flex justify-content-between mb-2 gap-4">
              <span className="fs-13 fw-semibold">{params.data.reviewedByName}</span>
              {params?.data?.createdAt && (
                <span className="text-muted">
                  {formatDate(params?.data?.reviewedAt)}
                </span>
              )}
            </div>
            <p className="m-0 fs-13">
              {params?.data?.rejectionReason}
            </p>
          </div>
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        show={showPopover}
        placement="bottom"
        overlay={popover}
        trigger={["hover", "focus"]}
        onToggle={handleToggle}
      >
        <span
          ref={targetRef}
          className={`text-${
            status === "draft"
              ? "black"
              : status === "review pending"
              ? "warning"
              : status === "completed"
              ? "secondary"
              : "danger"
          }`}
          style={{ position: "relative", zIndex: 1 }}
        >
          {params.data.stateName} {(params.data.stateName === "Review Pending" && Math.abs(calculateDayDifference(params.data.updatedAt)) > 0) ?  
          <span className="badge background-cancelled">Due: {Math.abs(calculateDayDifference(params.data.updatedAt))} days ago</span>      
          : ""}
        </span>
      </OverlayTrigger>
    );
  } else return "";
};
